import { NgGenericComponentsModule } from '@al/ng-generic-components';
/** Nepal Framework Libraries */
import { NgNavigationModule } from '@al/ng-navigation-components';
import { NgModule } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule
} from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';
import {
    O3CoreModule,
} from '@o3/core';
/** O3 Framework Libraries  */
import { O3DesignModule } from '@o3/design';

import { environment as appConfiguration } from '../environments/environment';
/** Internal Modules */
import { SharedModule } from '../modules/shared/shared.module';
/** Internal Components */
import { AppComponent } from './app.component';
import { FallthroughComponent } from './fallthrough/fallthrough.component';
import { GeneralErrorComponent } from './general-error/general-error.component';
import { HomeRouteComponent } from './home-route/home-route.component';
import { InitiatePasswordResetComponent } from './initiate-password-reset/initiate-password-reset.component';
import { LoginComponent } from './login';
import { LogoutComponent } from './logout';

import { MaterialModule } from './material.module';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { ResetConfirmationComponent } from './reset-confirmation/reset-confirmation.component';
import { SignupActivateComponent } from './signup-activate/signup-activate.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { WelcomeComponent } from './welcome/welcome.component';

import { routing } from './app.routing';
import { MonacoEditorModule, MONACO_PATH } from '@materia-ui/ngx-monaco-editor';
import { SignupComponent } from './signup/signup.component';
import { CardModule } from 'primeng-lts/card';
import { InputTextModule } from 'primeng-lts/inputtext';
import { AccordionModule } from 'primeng-lts/accordion';
import { ButtonModule } from 'primeng-lts/button';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { TooltipModule } from 'primeng-lts/tooltip';

@NgModule({
    declarations: [
        AppComponent,
        FallthroughComponent,
        GeneralErrorComponent,
        HomeRouteComponent,
        InitiatePasswordResetComponent,
        PasswordResetComponent,
        SignupActivateComponent,
        ResetConfirmationComponent,
        LoginComponent,
        LogoutComponent,
        TermsOfServiceComponent,
        WelcomeComponent,
        SignupComponent
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        SharedModule.forRoot(),
        FormsModule,
        NgNavigationModule,
        O3CoreModule.forRoot(appConfiguration),
        O3DesignModule,
        ReactiveFormsModule,
        MaterialModule,
        NgGenericComponentsModule,
        RouterModule,
        routing,
        MonacoEditorModule,
        CardModule,
        InputTextModule,
        AccordionModule,
        ButtonModule,
        CheckboxModule,
        TooltipModule
    ],
    providers: [
        {
            provide: MONACO_PATH,
            useValue: 'https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.21.2/min/vs'
        },
        DatePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

